import { render, staticRenderFns } from "./ContractBasicInfoExplainedBox.vue?vue&type=template&id=55d260b0&"
import script from "./ContractBasicInfoExplainedBox.vue?vue&type=script&lang=js&"
export * from "./ContractBasicInfoExplainedBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports